import { getDefaultLocationGpsConfig, GPS_LOCATION_IDS } from '../data/locationGps';

const clone = (value) => JSON.parse(JSON.stringify(value));

// Mezcla por claves conocidas: filas antiguas sin una zona nueva siguen
// funcionando con los defaults versionados.
const mergeKnown = (defaultValue, candidateValue) => {
  if (defaultValue && typeof defaultValue === 'object' && !Array.isArray(defaultValue)) {
    return Object.fromEntries(Object.entries(defaultValue).map(([key, value]) => [
      key,
      mergeKnown(value, candidateValue && typeof candidateValue === 'object' ? candidateValue[key] : undefined),
    ]));
  }
  return candidateValue === undefined ? defaultValue : candidateValue;
};

export const normalizeLoadedLocationGpsConfig = (candidate) => {
  const config = mergeKnown(getDefaultLocationGpsConfig(), candidate);
  // Podado defensivo: solo las 5 zonas del mapa general participan.
  config.locations = Object.fromEntries(
    GPS_LOCATION_IDS.filter((id) => config.locations?.[id]).map((id) => [id, config.locations[id]]),
  );
  return config;
};

export const fetchLocationGpsConfig = async (signal) => {
  const response = await fetch('/api/config/location-gps', {
    headers: { Accept: 'application/json' },
    signal,
  });
  if (!response.ok) throw new Error(`El backend respondio ${response.status}.`);
  const payload = await response.json();
  return {
    config: normalizeLoadedLocationGpsConfig(payload.config),
    meta: payload.meta,
  };
};

export const getCachedLocationGpsConfig = () => clone(getDefaultLocationGpsConfig());
